/* Barre d'achat collante — gm. Genere par collant_kit.py, ne pas editer a la main. */
(function () {
  var BARRE = document.querySelector('[data-gm-collant]');
  if (!BARRE) return;
  var SEUIL = parseInt(BARRE.getAttribute('data-seuil'), 10) || 600;
  var bouton = BARRE.querySelector('[data-gm-collant-achat]');
  var vrai = document.querySelector('.product-form__submit, button[name="add"]');

  // Inutile de doubler le bouton quand le vrai est deja sous les yeux.
  var vraiVisible = false;
  if (vrai && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { vraiVisible = e[0].isIntersecting; peindre(); },
      { rootMargin: '-80px 0px -80px 0px' }).observe(vrai);
  }

  var dernier = 0;
  function peindre() {
    var y = window.scrollY || document.documentElement.scrollTop;
    var montre = y > SEUIL && !vraiVisible && y >= dernier - 4;
    BARRE.classList.toggle('est-visible', montre);
    BARRE.setAttribute('aria-hidden', montre ? 'false' : 'true');
    dernier = y;
  }
  var enAttente = false;
  window.addEventListener('scroll', function () {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () { peindre(); enAttente = false; });
  }, { passive: true });
  peindre();

  // Le bouton de la barre clique le vrai bouton : toute la mecanique
  // (offre quantite, tiroir panier) reste au meme endroit.
  //
  // 18/09/2026 : le scrollIntoView est parti. Il remontait la page jusqu'au
  // vrai bouton AVANT de le cliquer. Mesure sur telephone : depart a 6000 px,
  // apres le clic on se retrouvait a 1197 px, et le tiroir ne s'ouvrait
  // qu'ensuite. Le client voyait sa page sauter au lieu du panier.
  // b.click() suffit : le formulaire s'envoie et le tiroir coulisse, que le
  // bouton soit a l'ecran ou non.
  if (bouton) bouton.addEventListener('click', function () {
    var b = document.querySelector('.product-form__submit, button[name="add"]');
    if (!b) return;
    b.click();
  });
})();
